import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { getMetricsByDate } from '@wix/ambassador-ai-scheduling-assistant-v1-metrics/http';
import { HttpBaseClient } from '../BaseClient/HttpBaseClient';
import { MetricsClientBase } from './MetricsClientBase';
export class MetricsClient extends HttpBaseClient(MetricsClientBase) {
  constructor() {
    super(...arguments);
    _defineProperty(this, "getMetricsByDateImpl", getMetricsByDate);
  }
}
//# sourceMappingURL=MetricsClientHttp.js.map